import { autoinject, bindable } from 'aurelia-framework';

@autoinject
export class DynamicTableActionButton {
  @bindable isDelete = false;
  constructor() {}
}
